export const SMALL = 500;
export const MEDIUM = 900;
